(function(){
  var root=document.getElementById('st-drawer'); if(!root) return;
  var panel=root.querySelector('.dr-panel'), body=root.querySelector('[data-dr-body]'), foot=root.querySelector('[data-dr-foot]'),
      setBox=root.querySelector('[data-dr-set]'), ship=root.querySelector('[data-dr-ship]'), disc=root.querySelector('[data-dr-disc]'),
      sub=root.querySelector('[data-dr-sub]'), IMG=window.ST_IMG||{}, FREE=10000, cache={}, lastFocus=null;
  function money(c){ var s=(c/100).toFixed(2); return '$'+s.replace(/\.00$/,''); }
  function esc(t){ return String(t).replace(/[&<>"]/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function kind(h){ return h==='theory-001-tee'?'tee':(h==='theory-001-shorts'?'shorts':''); }
  function imgFor(it){ var k=kind(it.handle), c=(it.variant_options||[])[0]; return IMG[k+'|'+c]||it.image||''; }
  function counts(n){ document.querySelectorAll('[data-cart-count]').forEach(function(e){ e.textContent=n; e.hidden=(n===0); }); }
  function getCart(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }); }
  function product(handle){ if(cache[handle]) return Promise.resolve(cache[handle]); return fetch('/products/'+handle+'.js').then(function(r){ return r.json(); }).then(function(p){ cache[handle]=p; return p; }); }

  function render(cart){
    counts(cart.item_count);
    if(!cart.item_count){
      body.innerHTML='<div class="dr-empty">Nothing here yet.<br>Pick a piece off the rail.<br><a href="#shop" data-dr-close>Back to the rack</a></div>';
      foot.hidden=true; setBox.hidden=true; ship.innerHTML=''; return;
    }
    var html='';
    cart.items.forEach(function(it,i){
      var opts=(it.variant_options||[]).join(' / '), line=it.final_line_price, was=it.original_line_price;
      html+='<div class="dr-item"><div class="dr-img"><img src="'+esc(imgFor(it))+'" alt=""></div>'+
        '<div><div class="dr-name">'+esc(it.product_title)+'</div><div class="dr-var">'+esc(opts)+'</div>'+
        '<div class="dr-qty"><button type="button" data-dr-q="'+(i+1)+'" data-v="'+(it.quantity-1)+'" aria-label="Fewer">&minus;</button><span>'+it.quantity+'</span><button type="button" data-dr-q="'+(i+1)+'" data-v="'+(it.quantity+1)+'" aria-label="More">+</button></div></div>'+
        '<div class="dr-price">'+(was>line?'<s>'+money(was)+'</s>':'')+money(line)+'<button class="dr-rm" type="button" data-dr-q="'+(i+1)+'" data-v="0">Remove</button></div></div>';
    });
    body.innerHTML=html;
    sub.textContent=money(cart.items_subtotal_price);
    if(cart.total_discount>0){ disc.hidden=false; disc.querySelector('b').textContent='−'+money(cart.total_discount); } else { disc.hidden=true; }
    foot.hidden=false;
    var left=FREE-cart.items_subtotal_price;
    ship.innerHTML=(left>0?('You are '+money(left)+' away from free shipping'):'Free shipping unlocked')+'<i><b style="width:'+Math.min(100,Math.round(cart.items_subtotal_price/FREE*100))+'%"></b></i>';
    suggest(cart);
  }

  function suggest(cart){
    setBox.hidden=true;
    var tee=null, sh=null;
    cart.items.forEach(function(it){ var k=kind(it.handle); if(k==='tee'&&!tee) tee=it; if(k==='shorts'&&!sh) sh=it; });
    var base=null, want=''; if(tee&&!sh){ base=tee; want='theory-001-shorts'; } else if(sh&&!tee){ base=sh; want='theory-001-tee'; }
    if(!base) return;
    var color=(base.variant_options||[])[0], size=(base.variant_options||[])[1];
    product(want).then(function(p){
      var v=p.variants.filter(function(x){ return x.option1===color && x.option2===size && x.available; })[0]
         || p.variants.filter(function(x){ return x.option1===color && x.available; })[0];
      if(!v) return;
      var k=kind(want);
      setBox.innerHTML='<div class="dr-img"><img src="'+esc(IMG[k+'|'+color]||'')+'" alt=""></div><div><div class="dr-set-t">Complete the set · 5% off</div><div class="dr-set-n">'+esc(color)+' '+(k==='tee'?'Tee':'Shorts')+' · '+esc(v.option2)+' · '+money(v.price)+'</div><button type="button" data-dr-add="'+v.id+'">Add to set</button></div>';
      setBox.hidden=false;
    }).catch(function(){});
  }

  function open(){ lastFocus=document.activeElement; root.classList.add('open'); root.setAttribute('aria-hidden','false'); document.body.classList.add('dr-lock'); setTimeout(function(){ panel.focus(); },60); }
  function close(){ root.classList.remove('open'); root.setAttribute('aria-hidden','true'); document.body.classList.remove('dr-lock'); if(lastFocus&&lastFocus.focus){ try{ lastFocus.focus(); }catch(e){} } }
  function refresh(openIt){ return getCart().then(function(c){ render(c); if(openIt) open(); }); }

  root.addEventListener('click',function(e){
    var t=e.target;
    if(t.closest('[data-dr-close]')){ close(); return; }
    var q=t.closest('[data-dr-q]');
    if(q){ fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:+q.getAttribute('data-dr-q'),quantity:Math.max(0,+q.getAttribute('data-v'))})}).then(function(r){ return r.json(); }).then(render); return; }
    var a=t.closest('[data-dr-add]');
    if(a){ a.disabled=true; a.textContent='Adding…'; fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:+a.getAttribute('data-dr-add'),quantity:1})}).then(function(){ return refresh(false); }); }
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&root.classList.contains('open')) close(); });
  document.addEventListener('click',function(e){
    var c=e.target.closest&&e.target.closest('a.nav-cart');
    if(c){ e.preventDefault(); refresh(true); }
  });
  document.addEventListener('st:cart-added',function(){ setTimeout(function(){ refresh(true); },150); });
  window.STDrawer={open:function(){ refresh(true); },refresh:refresh};
})();
